// Côté d'un message dans le fil d'un point, façon messagerie (retour 9 de
// Julien, PS 11323) : du point de vue de la personne connectée, les messages
// de SON camp à droite, ceux de l'autre camp à gauche.
//
// Deux camps : Digital Team (auteur du client 3, comme le V1) et le client du
// point. Un message interne est toujours rédigé par Digital Team : il va du
// côté Digital Team, quel que soit l'auteur enregistré.

/** Client « Digital Team » du V1. */
export const DT_CLIENT_ID = 3;

export type MessageSide = 'right' | 'left';

export function messageSide(
  viewerIdClient: number | null | undefined,
  msg: { auteur_id_client: number; portee: 'public' | 'interne' },
): MessageSide {
  const viewerIsDt = viewerIdClient === DT_CLIENT_ID;
  const authorIsDt = msg.portee === 'interne' || Number(msg.auteur_id_client) === DT_CLIENT_ID;
  return viewerIsDt === authorIsDt ? 'right' : 'left';
}
